import React from 'react';
import type { IconProps } from '../types';

export const ClearMeasurements = (props: IconProps) => (
<svg width="22" height="22" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M29.667 20L20.0003 29.6667" stroke="white" stroke-width="4" stroke-linecap="square" stroke-linejoin="round"/>
<path d="M20.001 20L29.6676 29.6667" stroke="white" stroke-width="4" stroke-linecap="square" stroke-linejoin="round"/>
<rect x="3" y="2" width="43" height="44" rx="6" stroke="white" stroke-width="4" stroke-linecap="square" stroke-dasharray="9 9"/>
</svg>

);
export default ClearMeasurements;
